import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next';
import AddIcon from '@material-ui/icons/AddCircleOutline'
import { Button } from '@workboard/wobo-ui'
import axios from 'axios'
import { useClosedKrLock } from '../closedKrLock.context'

const KrRelationshipWrapper = (props) => {
  const { t } = props;
  const isClosedKr = useClosedKrLock()
  const [showKrr, setShowKrr] = useState(false)
  const [krrMetric, setKrrMetric] = useState(null)

  useEffect(() => {
    const { metric } = props
    // A KR saved from the panel gains its id after expandKrr already ran for it; keep that view.
    if (krrMetric && krrMetric.id !== metric?.id) {
      setShowKrr(false)
      setKrrMetric(null)
    }
    const isEnabled = wbConfig.isKRRelationshipEnabled && window.initKrRelationsComponent
    if (!metric?.id || !isEnabled) {
      return undefined; // nothing to load.
    }
    let cancelled = false
    axios.get(`/wb/vnext/okr/keyResults/${metric.id}/relationships?pageSize=1`)
      .then((response) => {
        if (!cancelled && (response?.data?.total ?? 0) > 0) {
          expandKrr(metric)
        }
      })
      .catch((err) => console.log(err))
    return () => {
      cancelled = true
    }
  }, [props?.metric?.id]);

  const expandKrr = (data) => {
    console.log('data', data)
    if (!data) {
      return
    }
    if (props.updateSingleItem) {
      props.updateSingleItem(data)
    }
    setKrrMetric(data)
    setShowKrr(true)
  }

  // Mount after the render that creates #edit-related-work-area; collapse/expand recreates it.
  useEffect(() => {
    if (!showKrr || !krrMetric) {
      return
    }
    window.initKrRelationsComponent('edit-related-work-area', {
      ...krrMetric,
      goalType: props?.goalDetails?.type, // 1: Team, 2: Individual
      canEdit: !isClosedKr,
    }, { location: 'KR_EDIT_SIDEPANEL', subLocation: 'KRR_COMPONENT' })
  }, [showKrr, krrMetric, props?.goalDetails?.type, isClosedKr])

  const loadKRrelationships = async (event) => {
    event?.stopPropagation()
    console.log('KrRelationshipWrapper props:', props)
    if (!isKRRelationshipEnabled || !window.initKrRelationsComponent) {
      return // nothing to load.
    }
    const isNewKr = props?.metric?.id === undefined // can only support edit for now
    if (isNewKr) {
      // const response = await
      if (!props?.saveKr && typeof props?.saveKr !== 'function') {
        return console.log('can only be added to existing KR ID for now')
      }
      console.log('props.krType', props?.krType)
      switch (props?.krType) {
        case 'rollupokrs':
        case 'survey':
          return props.saveKr(false, (data) => expandKrr(data))
        case 'person':
        case 'multipleIntervalTargets':
        case 'workstream':
        case 'mirrorkr':
        case 'cascade':
        case 'kpi':
        default:
          return props.saveKr((data) => expandKrr(data))
      }
    } else {
      setTimeout(() => expandKrr(props.metric), 1000)
    }
  }
  // check feature flag and remove itself.
  const isKRRelationshipEnabled = wbConfig.isKRRelationshipEnabled || false
  if (!isKRRelationshipEnabled) return <></>

  return (
    <div className="kr-relationships-wrapper" style={{ padding: '12px 0px' }}>
      {!showKrr && (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Button
            style={{
              padding: '4px 4px 4px 0px',
              fontSize: '14px',
              fontWeight: 700,
            }}
            kind="normal"
            onClick={loadKRrelationships}
            variant="ghost"
            className="krAlign-label"
            startIcon={
              <AddIcon
                style={{
                  cursor: 'pointer',
                  width: '18px',
                  color: '#596373',
                  fontWeight: 700,
                  margin: '0px 0px 0px 4px',
                }}
              />
            }
          >
          {t('Relationships')}
          </Button>
        </div>
      )}
      {showKrr && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div
              className={'icon icon-dropdown-14px'}
              data-testid="add-krr-arrow"
              onClick={() => setShowKrr(false)}
              style={{ marginTop: '8px', transform: 'rotate(180deg)' }}
            ></div>
            <div
              id="edit-related-work-area"
              style={{
                marginLeft: '12px',
                color: 'rgb(89, 99, 115)',
                fontWeight: '700',
                fontSize: '14px',
                width: '100%',
              }}
              className="edit-related-work-area"
            >
              Loading Key Result Relationships
            </div>
          </div>
          <div className="krBreak" aria-hidden="true" />
        </div>
      )}
    </div>
  )
}

export default withTranslation()(KrRelationshipWrapper)
